exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#source-management[data-v-a1c0146e]{margin-top:80px}.page-title[data-v-a1c0146e]{margin-bottom:20px}", ""]);

// exports
